import { render, staticRenderFns } from "./loadingComponent.vue?vue&type=template&id=f492b4ea&"
import script from "./loadingComponent.vue?vue&type=script&lang=js&"
export * from "./loadingComponent.vue?vue&type=script&lang=js&"
import style0 from "./loadingComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Users/massimo.tiefenthaler/source/repos/Fercam/logistics.LogisticsTool/frontend/logisticstool/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib'
installComponents(component, {VProgressCircular})
